const photo = {
  namespaced: true,
  state: {
    metadata: {
      'mod': 'photo'
    },
    censorshipTableData: {},
    issuesData: {}
  },
  getters: {},
  mutations: {},
  actions: {}
}

export default photo
